import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, withRouter } from 'react-router-dom';
import MainHeader from '../../components/MainHeader';
import MobileHeader from '../../components/MobileHeader';
import PageRoutes from './pageRoutes';
import CustomRoute from '../../components/CustomRoute';
import { authOperations } from '../Login/state';
import { businessPartnerOperations } from '../BusinessPartner/state';
import { mobileContactOperations } from '../MobileContact/state';
import MainFooter from '../../components/MainFooter';
import { ADMIN, USER, MOBILE_HEADER_RETURN, EMPTY_COUNT, MOBILE_MONTHLY_LIST, MOBILE_ORDERS_LIST, MOBILE_CONTACT_LIST, MOBILE_CONTACT_VIEW, KANA_YES, KANA_NO } from '../../../utils/constants';
import "../../../includes/custom/css/index.css";
import { ORDER_LIST } from '../MobileOrders/routes';
import { CONTACT_LIST } from '../MobileContact/routes';
import Confirmation from '../../components/Confirmation';
import { CONFIRMATION_LOGOUT } from '../../../utils/messages';
import Loader from '../../components/Loader';
import moment from 'moment-timezone';
import IdleTimer from 'react-idle-timer'
import { TIMEOUT } from '../../../config/settings';
import { setPage } from "../BPOrder/state/actions";

class MainContainer extends Component {
    constructor(props) {
        super(props)
        this.state = { showConfirmation: false };
    }

    componentDidMount() {
        if (USER === this.props.user.authorities.authority) {
            this.props.viewBusinessPartner({ businessPartnerCode: this.props.user.riyo_kigyo_id, userCode: this.props.user.user_cd })
                .then((result) => {
                    this.props.setPartnerCodes({
                        branchNumber: result.data.branchNumber,
                        mainNumber: result.data.mainNumber
                    });

                    this.props.getUnreadCount({
                        customerCode1: result.data.mainNumber,
                        customerCode2: result.data.branchNumber
                    });
                });
        }

        moment.tz.setDefault(this.props.timezone_id);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.props.setPageNum(this.props.page, this.props.location.pathname);          
        }
    }


    toggleConfirmation = () => {
        this.setState({ showConfirmation: !this.state.showConfirmation });
    }

    confirmationMessage = () => {
        return (
            <Confirmation
                message={CONFIRMATION_LOGOUT}
                showConfirmation={this.state.showConfirmation}
                buttons={[
                    { label: KANA_YES, action: this.props.logoutUser },
                    { label: KANA_NO, action: this.toggleConfirmation }
                ]}
            />
        );
    }

    render() {
        return (
            <div className="main-container" key={this.props.page}>
                <Loader />
                <IdleTimer timeout={TIMEOUT} onIdle={this.props.logoutUser}/>
                {this.confirmationMessage()}
                <div>
                    {
                        ADMIN === this.props.user.authorities.authority ?
                            this.adminScreen() : this.mobileScreen()
                    }
                </div>
                <MainFooter />
            </div>
        );
    }

    adminScreen() {
        return (
            <div>
                <MainHeader
                    {...this.props}
                    toggleConfirmation={this.toggleConfirmation}
                />
                <Switch>
                    {PageRoutes.AdminRoutes.map((route, i) => <CustomRoute key={i} {...route} />)}
                </Switch>
            </div>
        );
    }

    returnAction = (page) => {
        if (MOBILE_MONTHLY_LIST === page) {
            this.props.setMobilePage(MOBILE_ORDERS_LIST);
            this.props.history.push(ORDER_LIST);
        } else if (MOBILE_CONTACT_VIEW === page) {
            this.props.setMobilePage(MOBILE_CONTACT_LIST);
            this.props.history.push(CONTACT_LIST);
        }
    }

    mobileScreen() {
        let withReturn = EMPTY_COUNT <= MOBILE_HEADER_RETURN.indexOf(this.props.mobilePage);

        return (
            <div>
                <MobileHeader
                    {...this.props}
                    toggleConfirmation={this.toggleConfirmation}
                    withReturn={withReturn}
                    returnAction={() => { this.returnAction(this.props.mobilePage) }}
                />
                <Switch>
                    {PageRoutes.MobileRoutes.map((route, i) => <CustomRoute key={i} {...route} />)}
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.credentials,
        partner: state.auth.partnerCodes,
        unread: state.mobileContact.unread,
        mobilePage: state.auth.mobilePage,
        timezone_id: state.auth.timezone_id,
        page: state.bpOrder.page,
    }
};

const mapDispatchToProps = {
    extendExpiry: authOperations.extendExpiry,
    logoutUser: authOperations.logoutUser,
    setPartnerCodes: authOperations.setPartnerCodes,
    viewBusinessPartner: businessPartnerOperations.viewBusinessPartner,
    getUnreadCount: mobileContactOperations.getUnreadCount,
    setMobilePage: authOperations.setMobilePage,
    setPageNum: setPage
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainContainer));